import moment from 'moment';
import { HOUR_BUCKETS } from './hourBuckets';
import { WORKER_SCOPES } from './workerFilters';

const DAY_FORMAT = 'YYYY-MM-DD';

const TOGGLE_DEFAULTS = {showAssigned: false, showUnassigned: true, showUnscheduled: false, showHomes: true, autoZoom: true};

const storageKey = (userId) => `inspectionMapFilters_${userId}`;

const parseDay = (value) => {
    const day = moment(value, DAY_FORMAT, true);
    return day.isValid() ? day : null;
};

const restoreHiddenHours = (saved) => HOUR_BUCKETS
    .map(bucket => bucket.key)
    .filter(key => Array.isArray(saved) && saved.indexOf(key) !== -1);

// A range comes back as saved until it is both over and untouched since an earlier day,
// so a saved "today" moves on to the new today and a future date holds until it passes.
function restoreRange({start, end, savedOn}, today) {
    const [from, to, saved] = [start, end, savedOn].map(parseDay);

    if(!from || !to || !saved || to.isBefore(from)) {
        return [today.clone(), today.clone()];
    }

    const expired = to.isBefore(today, 'day') && saved.isBefore(today, 'day');
    return expired ? [today.clone(), today.clone()] : [from, to];
}

function readSaved(userId) {
    try {
        return JSON.parse(localStorage.getItem(storageKey(userId))) || {};
    } catch(e) {
        return {};
    }
}

export function loadFilters(userId, today = moment()) {
    const saved = readSaved(userId);

    const toggles = {};
    Object.keys(TOGGLE_DEFAULTS).forEach(key => {
        toggles[key] = typeof saved[key] === 'boolean' ? saved[key] : TOGGLE_DEFAULTS[key];
    });

    return {
        ...toggles,
        range: restoreRange(saved, today),
        workerScope: Object.values(WORKER_SCOPES).indexOf(saved.workerScope) !== -1 ? saved.workerScope : WORKER_SCOPES.INSPECTORS,
        workerIds: Array.isArray(saved.workerIds) ? saved.workerIds : [],
        hiddenHours: restoreHiddenHours(saved.hiddenHours),
    };
}

export function saveFilters(userId, {range, ...filters}, today = moment()) {
    try {
        localStorage.setItem(storageKey(userId), JSON.stringify({
            ...filters,
            start: range[0].format(DAY_FORMAT),
            end: range[1].format(DAY_FORMAT),
            savedOn: today.format(DAY_FORMAT),
        }));
    } catch(e) {
        // Storage can be full or blocked; the page still works, it just won't remember.
    }
}

export const isSingleDay = ([start, end]) => start.isSame(end, 'day');

export function stepDay([start], days) {
    const day = start.clone().add(days, 'day');
    return [day, day.clone()];
}
